<div class="grid" *ngIf="carInformacionTercero && (nivUsuario == 5 || (nivUsuario <4 && estFisicaTercero.idEstructuraFisica !== null && estFisicaTercero.idEstructuraFisica !== undefined && estFisicaTercero.idEstructuraFisica !== '') || (nivUsuario ==4 && agrTercero.idAgrupacion !== undefined && agrTercero.idAgrupacion !== null && agrTercero.idAgrupacion !== ''))
&& (widActividad || widEjecutivo || widMeses)">
  <div class="col-12 lg:col-12 md:col-12">
    <p-panel header="{{ 'INICIO_DASHBOARD.LBL_FILTROOFICINA' | translate }}">
      <div class="recuadro-widget">
        <form [formGroup]="formulario">
          <div *ngIf="cargando" class="text-center">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_PROCESANDO' | translate }}</span>
          </div>
          <div class="grid form-group" *ngIf="!cargando">
            <div class="col-12 lg:col-offset-1 md:col-4 lg:col-4" *ngIf="nivUsuario > 3">
              <div class="div-form">
                <label for="idZonal">{{ 'INICIO_DASHBOARD.LBL_ZONAL' | translate}}</label>
                <p-dropdown disableTab  id="idZonal" [options]="lisAgrupaciones"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cambioAgrupacion($event.value)"
                            formControlName="idAgrupacion" filter="filter" *ngIf="nivUsuario == 5"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            ></p-dropdown>
                <label class="falso-combo-texto" *ngIf="nivUsuario == 4">{{agrTercero.agrupacion}}</label>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label for="idOficina">{{ 'INICIO_DASHBOARD.LBL_OFICINA' | translate}}</label>
                <p-dropdown disableTab  id="idOficina" [options]="lisEstructuraFisica"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" *ngIf="nivUsuario > 3"
                            formControlName="idEstructuraFisica" filter="filter"
                            (onChange)="cambioOficina($event.value)"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            ></p-dropdown>
                <label class="falso-combo-texto" *ngIf="nivUsuario < 4">{{estFisicaTercero.estructuraFisica}}</label>
              </div>
            </div>
            <div class="col-12 lg:col-2 md:col-2">
              <button id="btnActualizarCargo" style="width: 100%; margin-bottom: 10px;"
                      class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                      label="{{'BTN_ACTUALIZAR' | translate }}"
                      type="button" (click)="actualizarWidget()"
                      pButton></button>
            </div>
          </div>
        </form>
      </div>
      <div class="grid">
        <div class="col-12 md:col-7 lg:col-7">
          <app-widget-prospecto-perfil-actividad [oficina]="oficina" (cargando)="cargarBusqueda($event, 'ACT')"
                                                 [refrescar]="refrescar"
                                                 [idOficina]="f.idEstructuraFisica.value" *ngIf="widActividad"
                                                 [idAgrupacion]="f.idAgrupacion.value"></app-widget-prospecto-perfil-actividad>
          <br>

          <app-widget-prospecto-perfil-mes (cargando)="cargarBusqueda($event, 'MES')" [refrescar]="refrescar"
                                           [idOficina]="f.idEstructuraFisica.value" *ngIf="widMeses"
                                           [idAgrupacion]="f.idAgrupacion.value"></app-widget-prospecto-perfil-mes>

        </div>
        <div class="col-12 md:col-5 lg:col-5" style="margin-top: -8px">
          <app-widget-prospecto-perfil-ejecutivo (cargando)="cargarBusqueda($event, 'EJE')" [refrescar]="refrescar"
                                                 [idOficina]="f.idEstructuraFisica.value" *ngIf="widEjecutivo"
                                                 [idAgrupacion]="f.idAgrupacion.value"></app-widget-prospecto-perfil-ejecutivo>

        </div>

      </div>


    </p-panel>
  </div>
</div>
